import { StudentExamPaperListPage } from './StudentExamPaperListPage';
export default StudentExamPaperListPage;